import { render, staticRenderFns } from "./CaptureRecordEditor.vue?vue&type=template&id=1d17828e&scoped=true&"
import script from "./CaptureRecordEditor.vue?vue&type=script&lang=js&"
export * from "./CaptureRecordEditor.vue?vue&type=script&lang=js&"
import style0 from "./CaptureRecordEditor.vue?vue&type=style&index=0&lang=css&"
import style1 from "./CaptureRecordEditor.vue?vue&type=style&index=1&id=1d17828e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d17828e",
  null
  
)

/* custom blocks */
import block0 from "./CaptureRecordEditor.vue?vue&type=custom&index=0&blockType=i18n&lang=yaml"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d17828e')) {
      api.createRecord('1d17828e', component.options)
    } else {
      api.reload('1d17828e', component.options)
    }
    module.hot.accept("./CaptureRecordEditor.vue?vue&type=template&id=1d17828e&scoped=true&", function () {
      api.rerender('1d17828e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/RTypeDetectionTrend/CaptureRecordEditor.vue"
export default component.exports